"use strict";

var ourPromiseIconAnimation = (function () {
    return {
        executing: false,
        init: function () {
            this.executing = true;
            if ("IntersectionObserver" in window) {
                var config = {
                    root: null,
                    rootMargin: "0px",
                    threshold: 1.0
                };

                let observer = new IntersectionObserver(onIntersection, config);
                let target = document.querySelector(".our-promise-icons");
                observer.observe(target);
            }
        },
        executingIcons: [],
        restart: function () {
            $(".our-promise-icons .icon-container img").each(function () {
                $(this).removeClass("animate");
            });

            initiateIconMovement(".our-promise-icons .icon-container");
        },
        restartIcon: function (icon) {
            $(icon).removeClass("animate");
            var index = $(icon).data("index");

            setTimeout(function () {
                ourPromiseIconAnimation.executingIcons.push(index);
                jiggle(icon);
            }, 10);

            setTimeout(function () {
                ourPromiseIconAnimation.executingIcons = ourPromiseIconAnimation.executingIcons.filter(item => item !== index);
                jiggle(icon);
            }, 1000);
        }
    };

    function onIntersection(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting === true) {
                observer.unobserve(entry.target);
                initiateIconMovement(entry.target);
            }
        });
    }

    function initiateIconMovement(iconContainer) {
        ourPromiseIconAnimation.executing = true;

        setTimeout(function () {
            $(iconContainer).find(".movement-one").each(function (index) {
                jiggle(this);
            });
        }, 10);

        setTimeout(function () {
            $(iconContainer).find(".movement-two").each(function (index) {
                jiggle(this);
            });
        }, 160);

        setTimeout(function () {
            $(iconContainer).find(".movement-three").each(function (index) {
                jiggle(this);
            });

            //CLEAR EXECUTING FLAG; THE ANIMATION IS SET TO TAKE .5 SECONDS, TO BE "SAFE" TRIGGER THIS EVENT AFTER 1 SECOND
            setTimeout(function () {
                ourPromiseIconAnimation.executing = false;
            }, 1000);
        }, 310);
    }

    function jiggle(element) {
        $(element).addClass("animate");
    }
})();

(function () {
    $(window).on("load", function () {
        if (typeof ourPromiseIconAnimation !== "undefined") {
            ourPromiseIconAnimation.init();
        }

        //RESTART THE ANIMATION FOR EACH ICON
        $(".our-promise-icons img").mouseenter(function () {
            if (ourPromiseIconAnimation.executingIcons.includes($(this).data("index")) === false) {
                ourPromiseIconAnimation.restartIcon(this);
            }
        });
    });
})();